import React, { useContext, useEffect, useState } from "react";
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";

import { Button } from "../../../UI";
import { GeneralContext } from "../../../contexts/general.context";
import { CouriersType, ResultType } from "../../../utils/helper";
import { ShippingCourier } from "./ShippingCourier";
import classes from "./ShippingOption.module.css";
import { PGTranscriptRequestContext } from "../../../contexts/PGTranscriptRequest";

const forwardIcon = (
  <HiOutlineArrowSmRight style={{ fontSize: "16px", marginInline: "5px" }} />
);

export const ShippingInfo = ({ handleBack, onClick }) => {
  const [selected, setSelected] = useState();

  const { getCourier, couriers, currency, initializePaymentSchema } =
    useContext(GeneralContext);
  const { setPgTranscriptInfo, pgTranscriptInfo, copyType } = useContext(
    PGTranscriptRequestContext
  );

  useEffect(() => {
    getCourier();
    //eslint-disable-next-line
  }, []);

  const handleInput = ({ name, value }, price) => {
    setPgTranscriptInfo((prev) => ({ ...prev, [name]: value, price }));
    setSelected(value);
  };

  const proceed = (e) => {
    e.preventDefault();
    onClick((prevStep) => prevStep + 1);
  };

  const handleBackBtn = (e) => {
    handleBack((prev) => prev - 1);
  };

  useEffect(() => {
    if (copyType === "hard_copy") {
      initializePaymentSchema.resultType = ResultType["Hard Copy"];

      initializePaymentSchema.couriersType =
        CouriersType[pgTranscriptInfo?.courier];
    }

    //eslint-disable-next-line
  }, [pgTranscriptInfo]);

  return (
    <div className="flex flex-col gap-4">
      <p className={classes.heading}>Shipping Options</p>
      <p className={classes.subHeading}>
        Please select a shipping company for each request.
      </p>
      <div className={classes.optionsContainer}>
        {couriers.length > 0
          ? couriers.map((courier) => (
              <ShippingCourier
                key={courier.name}
                courier={courier}
                selected={selected}
                currency={currency}
                handleInput={handleInput}
              />
            ))
          : null}
      </div>
      <div className={classes.buttonContainer}>
        <Button
          className={classes.backButton}
          onClick={handleBackBtn}
          variant="invert"
        >
          <HiOutlineArrowSmLeft
            style={{
              fontSize: "16px",
              marginInline: "5px",
            }}
          />
          Back
        </Button>
        <Button disabled={!selected ? true : false} onClick={proceed}>
          Proceed
          {forwardIcon}
        </Button>
      </div>
    </div>
  );
};
